import { CompanyDto, FormStatuses } from 'dtos';

// Single source of truth for "should the PROCESS button be shown for this form".
// Server-side authorization in Form.ProcessAsync mirrors this rule, so hiding the
// button is a UX nicety only — bypassing the UI will still be rejected by the API.
//
// Rules (mirrors AddEditViewForm 10/20/2025 change order, extended 2026):
//   - Admins may always process Submitted forms.
//   - Project managers (the form's assigned PM, non-admin) may process Submitted
//     forms only when their company is project-manager-processable.
export function canShowProcessButton(args: {
  isAdmin: boolean;
  userId: string;
  projectManagerId?: string | null;
  formStatusId?: number | null;
  company?: Pick<CompanyDto, 'canProjectManagerProcessForms'> | null;
}): boolean {
  const { isAdmin, userId, projectManagerId, formStatusId, company } = args;

  if (formStatusId !== FormStatuses.Submitted) {
    return false;
  }

  if (isAdmin) {
    return true;
  }

  if (projectManagerId !== userId) {
    return false;
  }

  return Boolean(company?.canProjectManagerProcessForms);
}
